module.exports = __webpack_public_path__ + "img/icon-information-fill.aa0720d6.svg";